
// STYLE LINKS
import styles from '../css/cart.module.css';

// UTILS
import { formatValue } from '../../../scripts/formatValue';


export const RenderComplements = (item, index) => {
    const price = item.item.price ? formatValue(item.item.price) : 'Gratuito';

    return (
        <li key={index}>
            <div className={styles.complementArea}>
                <span className={styles.complementBullet} />

                <p className={styles.textComplement}>
                    {item.item.quantity > 1 ? `${item.item.quantity}x ` : ''}{item.item.complement}
                </p>

                <p className={styles.textComplementPrice}>{price}</p>
            </div>
        </li>
    );
};
